import React, { PureComponent } from "react";

import { Query } from "react-apollo";
import styled from "styled-components";
import { sortBy } from "lodash";

import Autocomplete from "../components/Autocomplete";

import citiesQuery from "../queries/citiesQuery.gql";
import MapWrapper from "../components/MapWrapper/MapWrapper";
import Loading from "../components/Loading/Loading";
import Header from "../components/Header/Header";
import Menu from "../components/Menu";
import ErrorView from "../components/Error";

import { belgiumBounds } from "../utils";

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100vh;
  overflow: hidden;
`;

const Content = styled.div`
  position: relative;
  flex-grow: 2;
`;

const Blackout = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;

  @media (min-width: 575px) {
    align-items: center;
  }
`;

const MapContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

const AutocompleteInput = styled.input`
  font-size: 24px;
  padding: 5px;
  text-align: center;
  border: none;

  @media (min-width: 575px) {
    font-size: 48px;
    padding: 10px;
    max-width: 90vw;
  }
`;

const AutocompleteRow = styled.div`
  font-size: 14px;
  padding: 10px;
  background: ${props => (props.isHighlighted ? "lightgray" : "white")};
  font-weight: ${props => (props.isHighlighted ? "bold" : "normal")};
  @media (min-width: 575px) {
    display: block;
    font-size: 22px;
  }
`;

const Title = styled.h1`
  color: white;
  text-align: center;
  margin-bottom: 10px;
  font-size: 26px;

  @media (min-width: 575px) {
    display: block;
    font-size: 36px;
  }
`;

const Text = styled.p`
  color: white;
  font-size: 16px;
  text-align: center;
  max-width: 90vw;
  margin: 0 auto;

  @media (min-width: 575px) {
    display: block;
    font-size: 36px;
  }
`;

const Center = styled.div`
  text-align: center;
  margin-top: 20px;
  @media (min-width: 575px) {
    margin-top: 0;
  }
`;

class HomePage extends PureComponent {
  state = {
    value: "",
    width: 0,
    height: 0
  };

  render() {
    const { value } = this.state;
    return (
      <PageWrapper>
        <Header />
        <Content>
          <Menu />
          <Blackout>
            <Center>
              <Text>
                Wat zijn de plannen van de partijen in jouw gemeente?<br />{" "}
                Ontdek wat ze als actiepunten hebben ingevuld!
              </Text>
              <Title>Vul je gemeente in</Title>
              <Query query={citiesQuery}>
                {({ loading, error, data }) => {
                  if (error) return <ErrorView error={error} />;
                  if (loading) return <Loading />;
                  let items = data.cities || [];
                  const scoredItems = sortBy(
                    items.map(item => ({
                      ...item,
                      isMatch:
                        item.name.trim().toLowerCase() ===
                          value.trim().toLowerCase() && !item.mainCity
                          ? -2
                          : item.name.trim().toLowerCase() ===
                            value.trim().toLowerCase()
                            ? -1
                            : 0
                    })),
                    "isMatch"
                  );

                  return (
                    <Autocomplete
                      getItemValue={item => {
                        return item ? `${item.name}-${item.postalCode}` : null;
                      }}
                      items={scoredItems}
                      renderItem={(item, isHighlighted) => (
                        <AutocompleteRow
                          isHighlighted={isHighlighted}
                          key={item.id}
                        >
                          {item.name}
                          {item.mainCity ? ` (${item.mainCity.name})` : ""}
                        </AutocompleteRow>
                      )}
                      renderInput={props => {
                        const { ref, ...rest } = props;
                        return <AutocompleteInput {...rest} innerRef={ref} />;
                      }}
                      shouldItemRender={(item, v) => {
                        return (
                          v.length &&
                          (item.name
                            .toLowerCase()
                            .indexOf(v.trim().toLowerCase()) !== -1 ||
                            item.postalCode
                              .toLowerCase()
                              .indexOf(v.trim().toLowerCase()) !== -1)
                        );
                      }}
                      value={value}
                      autoHighlight={true}
                      onChange={e => this.setState({ value: e.target.value })}
                      onSelect={(label, item) => {
                        if (item.mainCity && item.mainCity.name) {
                          this.props.history.push(
                            `/gemeente/${item.mainCity.slug}`
                          );
                        } else {
                          this.props.history.push(`/gemeente/${item.slug}`);
                        }
                      }}
                    />
                  );
                }}
              </Query>
            </Center>
          </Blackout>
          <MapContainer>
            <MapWrapper
              viewport={belgiumBounds()}
              height={"100vh"}
              defaultOptions={{
                disableDefaultUI: true
              }}
            />
          </MapContainer>
        </Content>
      </PageWrapper>
    );
  }
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/pages/Home.js